import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
// Must match the backend's `org_members_invite` enforcement. The legacy
// organization setting is folded into the effective permission set.
export function useCanInviteOrganizationMembers() {
    const { permissions, isLoading } = useEffectivePermissions({
        reason: 'useCanInviteOrganizationMembers',
    });
    return {
        canInviteMembers: !isLoading && permissions.has('org_members_invite'),
        loading: isLoading,
    };
}
//# sourceMappingURL=useCanInviteOrganizationMembers.js.map